import { Controller } from "@hotwired/stimulus";

// Reloads the current page on an interval while it's connected. Used on the
// brand Payments list while rows are being charged off-session, so each row's
// "Paying…" flips to "Paid" / "Card declined" without a manual refresh. The
// server only renders this controller while at least one row is charging, so
// once every charge settles the reloaded page drops the controller and the poll
// self-terminates. A hard cap stops a stuck row from reloading forever.
//
// Uses the globally-registered Turbo (do NOT import @hotwired/turbo-rails here —
// see recommendations_polling_controller.js for why a second Turbo boot breaks
// the calendar).
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 5000 },
    max: { type: Number, default: 24 }, // ~2 minutes
  };

  connect() {
    this.count = 0;
    this.timer = setInterval(() => this.reload(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  reload() {
    this.count += 1;
    if (this.count > this.maxValue) {
      clearInterval(this.timer);
      return;
    }
    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: "replace" });
    } else {
      window.location.reload();
    }
  }
}
